import React, { useState, useRef, useEffect, useMemo } from 'react';

const QuantitySelect = ({ value, onChange, options, disabled = false, className = '', style = {} }) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownAreaRef = useRef();
  const buttonRef = useRef();

  const displayValue = useMemo(() => {
    const selectedOption = options.find((opt) => opt.id === value);
    return selectedOption ? selectedOption.data : (value ?? 1);
  }, [value, options]);

  const outsideClickListener = (event) => {
    if (
      dropdownAreaRef.current &&
      !dropdownAreaRef.current.contains(event.target) &&
      buttonRef.current &&
      !buttonRef.current.contains(event.target)
    ) {
      setShowDropdown(false);
      removeClickListener();
    }
  };

  const removeClickListener = () => {
    document.removeEventListener('click', outsideClickListener);
  };

  const clickButton = () => {
    if (!disabled) {
      if (!showDropdown) {
        setShowDropdown(true);
        document.addEventListener('click', outsideClickListener);
      } else {
        setShowDropdown(false);
        removeClickListener();
      }
    }
  };

  const handleChange = (optionId) => {
    setShowDropdown(false);
    removeClickListener();
    onChange?.(optionId);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Escape') {
      setShowDropdown(false);
      removeClickListener();
    } else if (!['Tab', 'Shift', 'Control', 'Alt'].includes(e.key)) {
      e.preventDefault();
      clickButton();
    }
  };

  return (
    <div className={`quantity-select-wrapper ${className}`} style={style}>
      <select
        ref={buttonRef}
        className="quantity-select-button form-select form-select-sm"
        value={value ?? 1}
        disabled={disabled}
        onMouseDown={(e) => {
          e.preventDefault();
          clickButton();
        }}
        onKeyDown={handleKeyDown}
        style={{ width: '5rem', paddingRight: '0.5rem' }}
      >
        <option value={value ?? 1}>{displayValue}</option>
      </select>
      {showDropdown && (
        <div ref={dropdownAreaRef} className="quantity-select-dropdown">
          <div className="quantity-select-options">
            {options.map((opt) => (
              <div
                key={opt.id}
                className={`quantity-select-option ${opt.id === value ? 'selected' : ''}`}
                onClick={() => handleChange(opt.id)}
                onKeyDown={(e) => {
                  if (['Enter', ' '].includes(e.key)) {
                    handleChange(opt.id);
                    e.preventDefault();
                  }
                }}
                tabIndex={0}
              >
                {opt.data}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default QuantitySelect;
